__turbopack_context__.v({
  "workspaceMemberHoverCard": "gtAjhG_workspaceMemberHoverCard",
  "workspaceMemberHoverCard__actions": "gtAjhG_workspaceMemberHoverCard__actions",
  "workspaceMemberHoverCard__content": "gtAjhG_workspaceMemberHoverCard__content",
  "workspaceMemberHoverCard__email": "gtAjhG_workspaceMemberHoverCard__email",
  "workspaceMemberHoverCard__identity": "gtAjhG_workspaceMemberHoverCard__identity",
  "workspaceMemberHoverCard__name": "gtAjhG_workspaceMemberHoverCard__name",
  "workspaceMemberHoverCard__role": "gtAjhG_workspaceMemberHoverCard__role",
  "workspaceMemberHoverCard__text": "gtAjhG_workspaceMemberHoverCard__text",
  "workspaceMemberHoverCard__trigger": "gtAjhG_workspaceMemberHoverCard__trigger",
});
